module.exports = __webpack_public_path__ + "img/other_hourglass.bf1bc5e3.png";